import types from '../../config/types.js'
import { getPassLimit } from '../../config/passes.js'
import MockServer from './MockServer.js'
import GateService from 'Services/GateService.js'
import ServiceData from 'Mixins/ServiceData.js'

export default {
  mixins: [MockServer, ServiceData],
  data() {
    return {
      addressList: [this.getBlankAddress()],
      gateService: GateService,
      issuers: [],
      passes: [],
      passesValue: {
        guest: [],
        resident: [],
      },
      isExitPopupActive: false,
      currentGate: {},
      disconnectConfirmOpened: false,
    }
  },
  computed: {
    residentPasses() {
      const passes = this.passes.filter(pass => pass.type === 'resident')
      passes.map(pass => {
        pass.status = false
        pass.limit = getPassLimit(pass.name)
      })

      return passes
    },
    guestPasses() {
      const passes = this.passes.filter(pass => pass.type === 'guest')
      passes.map(pass => {
        pass.status = false
        pass.limit = getPassLimit(pass.name)
      })

      return passes
    },
    address() {
      return {
        address: this.currentGate?.property?.address,
        ip: this.currentGate?.sigur_server?.host || null,
        type: this.currentGate?.sigur_server?.type?.name || '',
      }
    },
    actions() {
      return {
        default: [
          {
            id: 4,
            type: types.actions.button,
            attr: {
              type: 'primary',
              label: 'Сохранить',
              disabled:
                this.addressListFilledLength === 0 ||
                (this.isSigurServer &&
                  this.passesValue.resident.length === 0),
              handler: () => this.toNextStep(),
            },
          },
          {
            id: 5,
            type: types.actions.button,
            attr: {
              type: 'secondary',
              label: 'Отмена',
              // disabled: !this.isAddNewAvailable,
              // icon: "plus-outlined",
              handler: () => {
                this.isExitPopupActive = true
              },
            },
          },
          {
            id: 6,
            type: types.actions.button,
            attr: {
              type: 'secondary',
              colored: 'danger',
              label: 'Отключить адрес',
              // icon: "trash",
              handler: () => this.openDisconnectConfirm(),
            },
          },
        ],
      }
    },
    formList() {
      return [
        {
          id: 'address',
          label: 'Выберите дом',
          required: true,
          type: types.components.select,
          width: 7,
          attr: {
            placeholder: 'Выберите дом',
            options: this.propertyListOptions,
          },
        },
        {
          id: 'server',
          label: 'Выберите сервер',
          required: true,
          type: types.components.select,
          width: 5,
          attr: {
            placeholder: 'Выбрать',
            options: this.serverListOptions,
            // options: [],     // Если не будет опций - покажет кнокку "Добавить сервер" (ниже)
          },
          nooptions: {
            label: 'Добавить сервер',
            icon: 'plus-outlined',
            handler: () => this.onAddServer(),
          },
        },
      ]
    },
    addressListFilledLength() {
      return this.addressList.reduce((acc, item) => {
        const addr = item.form.address
        const serv = item.form.server
        const issuer = item.form.issuer_id
        // const file = item.file;

        // if (!addr || !serv || !addr.length || !serv.length || !file) return acc;
        if (!addr || !serv || !addr.length || !serv.length) return acc

        const server = this.serverList.find(s => s.suid === serv)
        if (server?.type?.is_ble && !issuer) return acc

        ++acc
        return acc
      }, 0)
    },
    isAddNewAvailable() {
      return this.addressList.length === this.addressListFilledLength
    },
    selectedServerType() {
      const serverId = this.addressList[0]?.form?.server
      if (!serverId) return ''
      const server = this.serverList.find(s => s.suid === serverId)
      return server?.type?.name || ''
    },
    isSigurServer() {
      return this.selectedServerType === 'Sigur'
    },
    issuerOptions() {
      return this.issuers.map(issuer => ({
        id: issuer.id,
        label: issuer.name,
      }))
    },
    selectedServer() {
      const serverId =
        this.$store.getters.gateFormData?.configs[0]?.sigur_server_id

      return this.serverList.filter(server => server.suid === serverId)[0] ?? {}
    },
    selectedProperty() {
      const propertyId =
        this.$store.getters.gateFormData?.configs[0]?.property_id

      return (
        this.propertyList.filter(property => property.puid === propertyId)[0] ??
        {}
      )
    },
  },
  methods: {
    getBlankAddress() {
      return {
        id: Math.random(),
        form: {
          address: [],
          server: [],
          issuer_id: null,
        },
        // file: null,
      }
    },
    addAddress() {
      this.addressList.push(this.getBlankAddress())
    },
    removeAddress(id) {
      this.addressList = this.addressList.filter(item => item.id !== id)
    },
    onExitApprove() {
      this.isExitPopupActive = false
      this.$router.push({ name: 'Gates' })
    },
    onExitClose() {
      this.isExitPopupActive = false
    },
    openDisconnectConfirm() {
      this.disconnectConfirmOpened = true
    },
    onDisconnectConfirmClose() {
      this.disconnectConfirmOpened = false
    },
    onDisconnectConfirmApprove() {
      this.$store.dispatch('setIsLoading', true)
      this.deleteGate(this.$route.params.gateId)
    },
    deleteGate(gateId) {
      this.gateService
        .removeGates([gateId])
        .then(response => {
          this.disconnectConfirmOpened = false
          this.$store.dispatch('setIsLoading', false)
          this.$router.push({ name: 'Gates' })
        })
        .catch(error => {
          console.log(error)
          this.$store.dispatch('setIsLoading', false)
        })
    },
    toNextStep() {
      this.$store.dispatch('setIsLoading', true)
      const gateData = {
        suid: null,
        puid: null,
        issuer_id: null,
        resident_passes: [],
      }
      this.addressList.forEach(address => {
        gateData.puid = address.form.address
        gateData.suid = address.form.server
        gateData.issuer_id = address.form.issuer_id ?? null
      })

      if (this.isSigurServer) {
        const selectedPasses = [
          ...this.passesValue.resident,
          ...this.passesValue.guest,
        ]
        gateData.resident_passes = selectedPasses
          .filter(
            (pass, index, arr) => arr.findIndex(item => item.id === pass.id) === index
          )
          .map(pass => ({ id: pass.id, limit: pass.limit }))
      }

      this.gateService
        .updateGate(this.$route.params.gateId, gateData)
        .then(response => {
          this.$store.dispatch('setIsLoading', false)
          // this.$router.push({ name: 'Contacts' })
          this.$router.push({
            name: 'Address',
            params: { gateId: this.$route.params.gateId },
          })
        })
        .catch(error => {
          console.log(error)
          this.$store.dispatch('setIsLoading', false)
        })
    },
    toGate() {
      this.$router.push({
        name: 'Address',
        params: { gateId: this.$route.params.gateId },
      })
    },
  },
  async mounted() {
    const promises = []

    if (this.serverList.length === 0) {
      promises.push(
        this.getServers({
          organizationId: this.currentOrganizationId,
        })
      )
    }

    if (this.propertyList.length === 0) {
      promises.push(
        this.getProperties({
          organizationId: this.currentOrganizationId,
        })
      )
    }

    this.serverService
      .getIssuers()
      .then(response => {
        this.issuers = response.data
      })
      .catch(error => {
        console.log(error)
      })

    await Promise.all(promises)

    await this.gateService
      .getGate(this.$route.params.gateId)
      .then(response => {
        if (response.data) {
          this.currentGate = response.data
          this.addressList.map(address => {
            address.form.address = this.currentGate.property?.puid
            address.form.server = this.currentGate.sigur_server?.suid
            address.form.issuer_id = this.currentGate.issuer_id ?? null

            return address
          })

          this.currentGate.resident_passes.forEach(pass => {
            if (pass.type === 'resident') {
              this.passesValue.resident.push({
                id: pass.id,
                limit: getPassLimit(pass.name),
              })
            } else {
              this.passesValue.guest.push({
                id: pass.id,
                limit: getPassLimit(pass.name),
              })
            }
          })
        }
      })
      .catch(error => {
        console.log(error)
        this.$store.dispatch('setIsLoading', false)
      })

    this.gateService
      .getResidentPasses()
      .then(response => {
        this.passes = response.data
      })
      .catch(error => {
        console.log(error)
      })
  },
}
